export const DialogStyle = {
  dialogContent: {
    height: '300px',
    width: '600px',
    marginTop: '32px',
  },
  dialogContentText: {
    marginBottom: '19px',
  },
  linkedIn: {
    marginRight: '8px',
  },
  errorInput: {
    color: 'rgba(19, 15, 53, 0.34)',
  },
  inputColor: {
    color: 'rgba(19, 15, 53, 1)',
  },
};
